import { Card, Divider, Flex } from 'antd';
import TagComponent from 'components/Tags';
import TaskInfo from 'components/TaskInfo';
import { useTranslation } from 'react-i18next';
import useMrvQuery from 'screens/awd-dashboard/hooks/queries/useMrvQuery';
import { SelectTaskData } from 'screens/sales-group-progress';
import { STATUS } from 'utils/constants';
import { getStatusValues, renderDate } from 'utils/helpers';
import DryEventAccordion from './pipe-accordion/DryEventAccordion';

const DryEventContent = ({ data }: { data: SelectTaskData }) => {
  const { task, season } = { ...data };

  let status = task?.status;
  if (
    status === STATUS.UPCOMING &&
    new Date() > new Date(task?.dueDate ?? '')
  ) {
    status = STATUS.OVERDUE;
  }
  const { text: iconText, color: iconColor } = getStatusValues(status);

  const { t } = useTranslation();

  const { data: dryEventData } = useMrvQuery(season?.id);

  return (
    <>
      <Card>
        <div className="info-container">
          <TaskInfo header="Event Status">
            <TagComponent color={iconColor} label={iconText} />
          </TaskInfo>
          <TaskInfo header="Task Time Window">
            {renderDate(task?.dueDate)} {task?.endDate && '-'}{' '}
            {renderDate(task?.endDate, '')}
          </TaskInfo>
          <TaskInfo header={t('dashboard.taskCompletionDate')}>
            {renderDate(task?.inputDate)}
          </TaskInfo>
        </div>
      </Card>
      <Divider />
      <Flex gap={12} vertical>
        {dryEventData?.data?.map((pipeData, index) => (
          <DryEventAccordion
            key={`dryingEventAccordion-${index + 1}`}
            data={data}
            pipeData={pipeData}
            index={index}
          />
        ))}
      </Flex>
    </>
  );
};

export default DryEventContent;
